<template>
  <div
    class="divide-ontick-steel-300 border-ontick-steel-300 dark:divide-ontick-steel-500 dark:bg-ontick-graphite-500 grid w-full grid-cols-1 space-y-6 rounded-md border-2 bg-gray-50 py-4 dark:border-none dark:shadow-md md:grid-cols-4 md:space-y-0 md:divide-x 2xl:w-auto"
  >
    <div
      class="stat w-full space-y-2 px-4 md:w-52"
      content="Resultado total acumulado do dia."
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      <p
        class="text-ontick-carbon-900 whitespace-nowrap text-xs dark:text-gray-400"
      >
        Acumulado
      </p>
      <div class="flex items-center space-x-2">
        <div
          v-if="getTotalClosedPnl != 0"
          :class="
            getTotalClosedPnl > 0
              ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
              : 'text-ontick-red-500 rotate-180'
          "
          v-html="$icons.arrow_drop"
        ></div>
        <span
          class="h-3 w-3 rounded-full bg-gray-400"
          v-show="getTotalClosedPnl == 0"
        ></span>
        <h3 class="value">
          {{ getTotalClosedPnl | currency }}
        </h3>
      </div>
    </div>
    <div
      class="stat w-full space-y-2 px-4 md:w-52"
      content="Resultado total das operações em aberto."
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      <p
        class="text-ontick-carbon-900 whitespace-nowrap text-xs dark:text-gray-400"
      >
        Resultado total
      </p>
      <div class="flex items-center space-x-2">
        <ontick-loading-ellipsis-component
          v-if="getTotalOpenPnl == null || getTotalOpenPnl == undefined"
        />
        <div
          v-else-if="getTotalOpenPnl != 0"
          :class="
            getTotalOpenPnl > 0
              ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
              : 'text-ontick-red-500 rotate-180'
          "
          v-html="$icons.arrow_drop"
        ></div>

        <span class="h-3 w-3 rounded-full bg-gray-400" v-else></span>
        <h3 class="value">
          {{ getTotalOpenPnl | currency }}
        </h3>
      </div>
    </div>
    <div
      class="stat w-full space-y-2 px-4 md:w-52"
      content="Estratégias com posição aberta neste momento."
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      <p
        class="text-ontick-carbon-900 whitespace-nowrap text-xs dark:text-gray-400"
      >
        Posições abertas
      </p>
      <div class="flex items-center space-x-2">
        <!-- <div class="relative">
          <div
            v-show="
              investment.filter((x) => x.position_status != 'Zerado').length > 0
            "
            class="
              bg-ontick-green-500
              animate-ping
              absolute
              inline-flex
              h-3
              w-3
              rounded-full
              opacity-75
              mr-3
            "
          ></div>

          <div class="bg-ontick-green-500 h-3 w-3 rounded-full"></div>
        </div> -->
        <h3 class="value">
          {{ getOpenPositionsNumber }}
        </h3>
      </div>
    </div>
    <div
      class="stat w-full space-y-2 px-4 md:w-52"
      :content="`<div class='text-left'><span>Limites operacionais atingidos: <strong>${achievedObjectives}</strong></span>
      <ul class='list-disc ml-4'>
        <li>Ganhos: ${totalGain}</li>
        <li>Perdas: ${totalLoss}</li>
        <li>Tempo: ${totalTime}</li>
        <li>Operações: ${totalLimit}</li>
      </ul></div>`"
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      <p
        class="text-ontick-carbon-900 whitespace-nowrap text-xs dark:text-gray-400"
      >
        Objetivos atingidos
      </p>

      <div class="flex items-center space-x-2">
        <h3 class="value">
          {{ achievedObjectives }}/{{ getRunningInvestmentsNumber }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ontickLoadingEllipsisComponent from "../../../../../shared/components/basic/ontick-loading-ellipsis.component.vue";

export default {
  components: { ontickLoadingEllipsisComponent },

  props: { investment: { type: Array, default: [] } },

  computed: {
    ...mapGetters({
      getRunningInvestmentsNumber: "investment/getRunningInvestmentsNumber",
      getOpenPositionsNumber: "investment/getOpenPositionsNumber",
      getTotalOpenPnl: "investment/getTotalOpenPnl",
      getTotalClosedPnl: "investment/getTotalClosedPnl",
    }),

    achievedObjectives() {
      return this.investment.filter(
        (item) =>
          item.mask_gain || item.mask_limit || item.mask_loss || item.mask_time
      ).length;
    },
    totalGain() {
      return this.investment.filter((item) => item.mask_gain).length;
    },
    totalLoss() {
      return this.investment.filter((item) => item.mask_loss).length;
    },
    totalTime() {
      return this.investment.filter((item) => item.mask_time).length;
    },
    totalLimit() {
      return this.investment.filter((item) => item.mask_limit).length;
    },
  },
};
</script>

<style lang="scss" scoped>
.stat {
  @apply text-ontick-carbon-900 whitespace-nowrap text-xs dark:text-gray-400;
  .value {
    @apply text-ontick-carbon-900 whitespace-nowrap text-xl font-bold dark:text-gray-300;
  }
}
</style>
